import React from 'react';
import { graphql } from 'gatsby';
import { SEO } from '../components/2.0version/seo/Seo';
import { OtTemplateQuery, SanityLocaleString } from '../../graphql-types';
import { OtActivitesHerbergements } from '../modules/ot/OtActivitesHebergements';
import { OtBoutique } from '../modules/ot/OtBoutique';
import { OtBilleterie } from '../modules/ot/OtBilleterie';
import { OtHeader } from '../modules/ot/OtHeader';

interface IOtTemplate {
  data?: OtTemplateQuery;
}

const ACTIVITES_HEBERGEMENTS = {
  H: ['HOT', 'HLO', 'HCO', 'RET'],
  K: ['HPA', 'ACC'],
  G: ['HCO', 'HLO', 'VIL'],
  T: ['RES'],
  E: ['DEG', 'ASC', 'LOI', 'ITI', 'GRE', 'BIE'],
  U: ['PCU'],
  ITI: ['ASC', 'ITI'],
};
const BILLETERIE = {
  P: [],
  V: [],
  Y: [],
};
const BOUTIQUE = {};

const OtTemplate = ({ data }: IOtTemplate) => {
  const ingenieOt = data?.ingenieOt;

  const seo = <SEO rawMeta={{ metaTitle: data?.ingenieOt?.libelle as SanityLocaleString }} />;
  if (ingenieOt?.key) {
    if (ACTIVITES_HEBERGEMENTS?.[ingenieOt?.key]?.includes(ingenieOt?.keyId)) {
      return (
        <>
          {seo}
          <OtHeader ot={ingenieOt} />
          <OtActivitesHerbergements ot={ingenieOt} />
        </>
      );
    }
    if (BILLETERIE?.[ingenieOt?.key]) {
      return (
        <>
          {seo}
          <OtHeader ot={ingenieOt} />
          <OtBilleterie ot={ingenieOt} />
        </>
      );
    }
    if (BOUTIQUE?.[ingenieOt?.key]) {
      return (
        <>
          {seo}
          <OtBoutique ot={ingenieOt} />
        </>
      );
    }
  }
  return null;
};

export const QUERY = graphql`
  query OtTemplate($id: String) {
    ingenieOt(id: { eq: $id }) {
      id
      key
      keyId
      codePrestation
      codePrestataire
      pictosPartners {
        url
        alt
      }
      reservable
      onlyReservableOnIngenie
      reservableLinkIngenie {
        url
        langue
      }
      libelle {
        fr
        en
      }
      tarifs {
        id
        libelle {
          fr
          en
        }
        prix_max
        prix_min
        complement {
          fr
        }
      }
      localisation {
        gps {
          lat
          lng
        }
      }
      ouvertures {
        heure_debut
        heure_fin
        jours_semaine
        date_fin
        date_debut
      }
      displayableContact {
        tel
        address
        email
        webSite
        mainLocation
        mainLocationLibelle {
          fr
          en
        }
      }
      ...wishListFragment

      descriptifs {
        contenu {
          fr
          en
        }
        libelle
      }

      documents {
        url
        libelle
        langue
      }
      medias {
        id
        type
        attributs {
          type
          libelle {
            fr
          }
        }
        url
      }
      liens {
        id
        type
        url
      }
      socials {
        type
        url
      }
      content {
        resume {
          id
          label {
            en
            fr
          }
          picto
          pictoUrl
          valeur
        }
        equipments {
          id
          label {
            en
            fr
          }
          picto
          pictoUrl
        }
        types {
          id
          label {
            en
            fr
          }
          critereLabel {
            en
            fr
          }
        }
      }
      parentRubriques {
        slug
      }
      liaisons_objets {
        id_objet
      }
    }
  }
`;

export default OtTemplate;
